export default "__VITE_ASSET__B56SAIiL__"